import styled, { keyframes, css } from 'styled-components';
import Colors from 'library/constants/colors';
import { ItemActionHorizontal } from 'library/components/item/styles';
import {
  IconBase,
} from 'library/styles/icon';
import { Icon as IconCommon } from '../item/styles';

export const like = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Icon = styled(IconBase)`
  color: ${Colors.violet};
`;

export const ThirdIcon = styled(IconCommon)`
  position: absolute;
  right: 5px;
  top: -20px;
  transform: rotate(-34deg);
  animation: ${like} 1s linear;
  animation-fill-mode: forwards;
  opacity: 0;
  transition: transform 1s linear;
`;

export const SecondIcon = styled(IconCommon)`
  position: absolute;
  right: -10px;
  top: -8px;
  transform: rotate(7deg);
  animation: ${like} 1s linear;
  animation-fill-mode: forwards;
  opacity: 0;
  transition: transform 1s linear;
`;

const styles = css`
  animation: ${like} 1s linear;
`;

export const LikeItemActionHorizontal = styled(ItemActionHorizontal)`
  white-space: nowrap;
  //
  //i {
  //  color: #fff !important;
  //}
  
  i:not(:first-of-type) {
    filter: drop-shadow(0px 2px 8px rgba(45,49,50,1));
  }

  
  ${({ isActive }) => (isActive ? `
    background-color: ${Colors.violet};
    color: ${Colors.shade08}  !important;
    
    i {
      color: ${Colors.shade08} !important;
    }
    
    &:hover {
      background-color: ${Colors.shade08};
      color: ${Colors.violet} !important;
  
      i {
        color: ${Colors.violet} !important;
      }
    }
  ` : `
     background-color: ${Colors.shade08};
     color: ${Colors.violet} !important;
       
         
    &:hover {
      background-color: ${Colors.shade08};
      color: ${Colors.violet} !important;
  
      i {
        color: ${Colors.violet} !important;
      }
    }
  `)};
  
  ${({ disabled }) => disabled && `
    background-color: ${Colors.shade05};
    opacity: 0.5;

    i {
        cursor: not-allowed;
    }
  `}

  ${({ isLoading }) => isLoading && `
      background-color: ${Colors.violet} !important;
      
      i {
        position: relative;
        color: #fff !important;

        :before {
          position: absolute;
          ${styles}
        }
        
        span {
          position: absolute;
          ${styles}
        }
      }
      
      span {
        visibility: hidden;
      }
  `}
  
`;
